<template>
  <div class="temp">
    <div class="swiper-container dataScreen">
      <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="@/assets/temp/p1c.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/temp/p2c.png" />
          </div>
      </div>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </div>
</template>

<script>

import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
export default {
  name: 'index',
  components: {
  },
  data() {
    return {
    }
  },
  mounted() {
    /* eslint-disable */
    let _swiper = new Swiper ('.swiper-container', {
      autoplay: false,
      loop: true,
      // touchRatio: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    })
    /* eslint-disable */
  },
  methods: {

  }
}
</script>

<style scoped>
.temp{position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 9999;background-color: #070d4b;}
.swiper-container{width: 100%;height: 100%;}
.swiper-slide{width: 100%;height: 100%;}
.swiper-slide img{width: 100%;height: 100%;object-fit: contain;}
</style>
<style media="screen">
.swiper-container.dataScreen .swiper-pagination .swiper-pagination-bullet{width: 40px;height: 10px;background-color: #0b356f;opacity: 1;cursor: pointer;border-radius: 6px;}
.swiper-container.dataScreen .swiper-pagination .swiper-pagination-bullet-active{width: 40px;height: 10px;background-color: #25d5fc;opacity: 1;border-radius: 6px;}
</style>
